export default __webpack_public_path__ + "static/media/mol_card_2.5f7c5fc1.png";